import { stateOf } from './status';

export const SENSOR_META = {
  CURRENT_R: { label: 'R phase current', unit: 'A' },
  CURRENT_Y: { label: 'Y phase current', unit: 'A' },
  CURRENT_B: { label: 'B phase current', unit: 'A' },
  CURRENT_AVG: { label: 'Average current', unit: 'A' },
  CURRENT_IMBALANCE_PCT: { label: 'Phase current imbalance', unit: '%' },
  VOLTAGE_R: { label: 'R phase voltage', unit: 'V' },
  VOLTAGE_Y: { label: 'Y phase voltage', unit: 'V' },
  VOLTAGE_B: { label: 'B phase voltage', unit: 'V' },
  VOLTAGE_AVG: { label: 'Average voltage', unit: 'V' },
  VOLTAGE_IMBALANCE_PCT: { label: 'Phase voltage imbalance', unit: '%' },
  PF_R: { label: 'R phase PF', unit: '' },
  PF_Y: { label: 'Y phase PF', unit: '' },
  PF_B: { label: 'B phase PF', unit: '' },
  PF_AVG: { label: 'Average PF', unit: '' },
  TOTAL_KW: { label: 'Power', unit: 'kW' },
  FLOWRATE: { label: 'Flow', unit: 'm3/h' },
};

export function finiteNumber(value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function formatValue(value, unit = '', digits = 3) {
  const number = finiteNumber(value);
  if (number === null) return 'Missing';
  const text = number.toLocaleString('en-IN', { maximumFractionDigits: digits });
  return unit ? `${text} ${unit}` : text;
}

export function formatRange(spec, unit = '') {
  if (!spec || spec.available === false) return 'Range unavailable';
  const low = finiteNumber(spec.expected_low);
  const high = finiteNumber(spec.expected_high);
  if (low === null || high === null) return 'Range unavailable';
  return `${formatValue(low, unit)} - ${formatValue(high, unit)}`;
}

export function formatIst(value) {
  if (!value) return 'Unavailable';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unavailable';
  const formatted = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
  return `${formatted} IST`;
}

export function isStale(payload, now = Date.now(), maxMinutes = 15) {
  if (!payload) return false;
  const state = stateOf(payload);
  const running = String(payload.running_status || payload.reported_pump_status || '').toUpperCase();
  if (running !== 'ON' || !['NORMAL', 'ANOMALY'].includes(state)) return false;
  if (!payload.last_updated) return true;
  const timestamp = new Date(payload.last_updated).getTime();
  return !Number.isFinite(timestamp) || now - timestamp > maxMinutes * 60_000;
}

export function baseDeviationCode(item) {
  if (!item) return '';
  return String(item.code || item.field || '')
    .toUpperCase()
    .replace(/_(HIGH|LOW)$/, '');
}

export function deviationMeta(item) {
  if (!item) return { label: 'Reading', unit: '' };
  return SENSOR_META[baseDeviationCode(item)] || {
    label: item.label || item.sensor || 'Reading',
    unit: '',
  };
}
